


























































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class ManagerFooter extends Vue {
  private logOut(): void {
    localStorage.removeItem("partnerId");
    localStorage.removeItem("partnerCode");
    window.location.replace("/login");
  }
}
